import React from "react";
import styles from "./KindLabel.module.scss";

export type KindType = "fs" | "deposit";

type Props = {
  kinds: KindType[];
};

const kindConfig: Record<KindType, { label: string; emoji: string }> = {
  fs: { label: "FS", emoji: "🎰" },
  deposit: { label: "Deposit", emoji: "💵" },
};

const kindClassMap: Record<KindType, string> = {
  fs: styles["kind-label--fs"],
  deposit: styles["kind-label--deposit"],
};

export const KindLabel: React.FC<Props> = ({ kinds }) => {
  if (!Array.isArray(kinds) || kinds.length === 0) {
    return <>-</>;
  }
  return (
    <div className={styles.wrapper}>
      {kinds?.map((kind, index) => (
        <div
          key={index}
          className={`${styles["kind-label"]} ${kindClassMap[kind]}`}
        >
          <span className={styles.text}>{kindConfig[kind].label}</span>
          <span className={styles.emoji}>{kindConfig[kind].emoji}</span>
        </div>
      ))}
    </div>
  );
};
